import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface PillBadgeProps {
    children: ReactNode
    className?: string
    tone?: 'light' | 'dark'
    dot?: ReactNode
}

/** Small rounded label used for eyebrows above headlines. */
export const PillBadge: FC<PillBadgeProps> = ({ children, className, tone = 'light', dot }): ReactNode => {
    return (
        <span
            className={cn(
                'eyebrow inline-flex items-center gap-2 rounded-full border px-3 py-1.5',
                tone === 'light' ? 'border-ink/10 bg-paper/70 text-ink-soft backdrop-blur' : 'border-white/10 bg-white/[0.04] text-white/70',
                className
            )}
        >
            {dot}
            {children}
        </span>
    )
}
